import React from "react";
import "./kycModal.css";

interface TermsScreenProps {
  title?: string;
  termsHtml?: string;
  onAccept: () => void;
  onDecline: () => void;
  classNames?: {
    backdrop?: string;
    container?: string;
    title?: string;
    input?: string;
  };
  styles?: {
    backdrop?: React.CSSProperties;
    container?: React.CSSProperties;
    title?: React.CSSProperties;
    input?: React.CSSProperties;
  };
}

export const TermsScreen: React.FC<TermsScreenProps> = ({
  title = "Terms & Conditions",
  termsHtml = "<p>You are required to provide a valid government-issued ID and complete a face verification scan. Ensure your information is accurate and the process is completed in one session.</p>",
  onAccept,
  onDecline,
  classNames,
  styles,
}) => {
  return (
    <div className={`kyc-backdrop ${classNames?.backdrop || ""}`} style={styles?.backdrop}>
      <div className={`kyc-container ${classNames?.container || ""}`} style={styles?.container}>
        <h2 className={`kyc-title ${classNames?.title || ""}`} style={styles?.title}>{title}</h2>
        <div
          style={{
            maxHeight: 260,
            overflow: "auto",
            padding: 0,
            margin: "6px 0 16px 0",
            color: "#111827",
            lineHeight: 1.6,
            fontSize: 14
          }}
          dangerouslySetInnerHTML={{ __html: termsHtml }}
        />
        <div style={{ display: "grid", gap: 8, gridTemplateColumns: "1fr 1fr", alignItems: "center" }}>
          <button
            type="button"
            className={`kyc-input ${classNames?.input || ""}`}
            style={{
              ...(styles?.input || {}),
              background: "linear-gradient(90deg, #FF8A00 0%, #FF3D77 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: 10,
              cursor: "pointer"
            }}
            onClick={onAccept}
          >
            Accept
          </button>
          <button
            type="button"
            className={`kyc-input ${classNames?.input || ""}`}
            style={{ ...(styles?.input || {}), background: "", color: "#6b7280", border: "1px solid #d1d5db", borderRadius: 8, padding: 10, cursor: "pointer" }}
            onClick={onDecline}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};


